import { Plugins } from '@leverege/plugin';
export default Plugins.createFactory('GroupedTextFilterFieldFilter', {
  pluginKey: 'toFilter',
  strategy: Plugins.ARGS
});